import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-faq',
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.css'],
    standalone: false
})
export class FaqComponent implements OnInit {
  questions = [
    {
      question: 'Wat is Steddie?',
      answer: 'Steddie is een stichting met een platform waarop activiteiten voor mensen met een beperking staan.'
    },
    {
      question: 'Waarom een speciale website voor mensen met een beperking?',
      answer: 'In de Nederlandse wet staat dat ‘mensen met een beperking mee moeten kunnen doen in de samenleving’. Dat kan alleen als je weet wat er voor deze mensen te doen is. Steddie maakt dit zichtbaar op Steddie.nl'
    },
    {
      question: 'Wat is een beperking?',
      answer: 'Er zijn verschillende soorten beperkingen. Denk aan psychische klachten, verstandelijke- en/of lichamelijke beperkingen, maar bijvoorbeeld ook Autisme.'
    },
    {
      question: 'Wie kan er gebruik maken van Steddie.nl?',
      answer: 'Dat kunnen mensen met een beperking zijn, maar ook hun familieleden of begeleiders. Eigenlijk iedereen die op zoek is naar een leuke activiteit voor mensen met een beperking.'
    },
    {
      question: 'Hoe weet ik of een activiteit geschikt is voor mijn beperking?',
      answer: 'Bij het plaatsen van een activiteit moet de organisator aangeven voor wie de activiteit geschikt is. Dit vind je dus terug bij de activiteit.'
    },
    {
      question: 'Wat kost het gebruik van Steddie.nl?',
      answer: 'Aan het zoeken naar activiteiten of het plaatsen van activiteiten zijn geen kosten verbonden. Steddie is voor gebruikers dus helemaal gratis!'
    },
    {
      question: 'Organiseert Steddie zelf ook activiteiten?',
      answer: 'Nee, wij publiceren activiteiten van andere organisaties. Denk hierbij aan (sport)verenigingen of wijkcentra.'
    },
    {
      question: 'Waarom staan nog niet alle activiteiten bij mij in de buurt op de website?',
      answer: 'Steddie probeert zoveel mogelijk activiteiten te plaatsen. Daarvoor zijn we afhankelijk van tips van gebruikers en van organisaties die een activiteit hebben. Laat het ons daarom weten als er iets bij jou in de buurt wordt georganiseerd!'
    },
    {
      question: 'Ik ben van een organisatie en wil iets plaatsen, kan dat?',
      answer: 'Organisaties kunnen in een afgeschermd gedeelte van de website hun activiteit plaatsen.'
    },
    {
      question: 'Ik wil een activiteit organiseren, maar weet niet hoe. Kan Steddie mij helpen?',
      answer: 'Jazeker. Kijk bij ‘Voor organisaties’ voor meer informatie.'
    }
  ];

  constructor() { }

  ngOnInit(): void {}

}
